import { AssetType, Url } from "../../../index";

interface AssetProps {
	url: Url;
	type: AssetType;
}

class Asset {
	constructor(private _: AssetProps) {}

	get url() {
		return this._.url;
	}

	get type() {
		return this._.type;
	}

	static image(url: Url) {
		return new Asset({ url, type: AssetType.IMAGE });
	}

	static video(url: Url) {
		return new Asset({ url, type: AssetType.VIDEO });
	}

	static fromJson(json: any) {
		return new Asset({
			url: json.url,
			type: json.type,
		});
	}

	toJson() {
		return {
			url: this._.url,
			type: this._.type,
		};
	}
}

export { Asset };
